import React from "react";

interface ErrorProps {
  error: string;
  onRetry: () => void;
}

const Error: React.FC<ErrorProps> = ({ error, onRetry }) => {
  return (
    <div className="container" id="campaign-container">
      <div
        className="col d-flex align-items-center justify-content-center"
        style={{ minHeight: "400px" }}
      >
        <div className="text-center">
          <div className="alert alert-danger" role="alert">
            {error}
          </div>
          <button className="btn btn-primary" onClick={onRetry}>
            Retry
          </button>
        </div>
      </div>
    </div>
  );
};

export default Error;
